// extracted by mini-css-extract-plugin
module.exports = {"projectTechstack":"ProjectTechstack-module--projectTechstack--EwXzF","title":"ProjectTechstack-module--title--VTvEN Project-module--metatitle--2k2Se"};